var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7901 4.22001C16.8301 1.27001 12.0301 1.27001 9.09015 4.22001C7.02015 6.27001 6.40015 9.22001 7.20015 11.82L2.50015 16.52C2.17015 16.86 1.94015 17.53 2.01015 18.01L2.31015 20.19C2.42015 20.91 3.09015 21.59 3.81015 21.69L5.99015 21.99C6.47015 22.06 7.14015 21.84 7.48015 21.49L8.30015 20.67C8.50015 20.48 8.50015 20.16 8.30015 19.96L6.36015 18.02C6.07015 17.73 6.07015 17.25 6.36015 16.96C6.65015 16.67 7.13015 16.67 7.42015 16.96L9.37015 18.91C9.56015 19.1 9.88015 19.1 10.0701 18.91L12.1901 16.8C14.7801 17.61 17.7301 16.98 19.7901 14.93C22.7401 11.98 22.7401 7.17001 19.7901 4.22001ZM14.5001 12C13.1201 12 12.0001 10.88 12.0001 9.50001C12.0001 8.12001 13.1201 7.00001 14.5001 7.00001C15.8801 7.00001 17.0001 8.12001 17.0001 9.50001C17.0001 10.88 15.8801 12 14.5001 12Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordGray);
export default __webpack_public_path__ + "static/media/password-gray.c4a17838d3e4d8af75c2f035b3b6203a.svg";
export { ForwardRef as ReactComponent };